import React, { useEffect, useRef } from 'react';
import './Shows.css';

// Bandsintown widget — syncs automatically whenever you update events on Bandsintown.
// To add shows: log into your Bandsintown for Artists account and add events there.
// They will appear here automatically within a few minutes.


export default function Shows() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Dynamically inject the Bandsintown widget script after mount
    const script = document.createElement('script');
    script.src = 'https://widget.bandsintown.com/main.min.js';
    script.charset = 'utf-8';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Clean up script on unmount to avoid duplicates on navigation
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div className="section-container">
        <h1 className="section-title">Shows</h1>
        <div className="section-rule" />

        <div className="shows-header">
          <p className="shows-subtitle">Live dates — updated automatically via Bandsintown</p>
          <a
            href="https://www.bandsintown.com/a/echo-hill"
            target="_blank"
            rel="noopener noreferrer"
            className="shows-bit-link"
          >
            <BITIcon /> Follow on Bandsintown
          </a>
        </div>

        {/* Bandsintown widget anchor */}
        <div className="shows-widget" ref={containerRef}>
          <a
            className="bit-widget-initializer"
            data-artist-name="ID_15620840"
            data-display-local-dates="false"
            data-display-past-dates="false"
            data-auto-style="false"
            data-text-color="#f0ece4"
            data-link-color="#c94a1a"
            data-background-color="rgba(0,0,0,0)"
            data-display-limit="15"
            data-display-start-time="true"
            data-link-text-color="#ffffff"
            data-display-lineup="true"
            data-display-play-my-city="false"
            data-separator-color="rgba(255,255,255,0.1)"
          />
        </div>
      </div>
    </div>
  );
}

function BITIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{ flexShrink: 0 }}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 16.5c-3.5 0-6.6-1.8-8.4-4.5.04-2.8 5.6-4.3 8.4-4.3s8.36 1.5 8.4 4.3c-1.8 2.7-4.9 4.5-8.4 4.5z"/>
    </svg>
  );
}

function FBIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{ flexShrink: 0 }}>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
}
